import React, { useEffect, useMemo, useState } from 'react';
import { getDescendantProp, lang } from '../../Utils';
import { Caption } from './Caption';
import { Body } from './Body';
import { Header } from './Header';
import { Paginator } from './Paginator';
import './Table.css';
import { TableContext } from './TableContext';
import Loader from '../loader/Loader';

const Table = ({ responsive, dataSet, pagination, hover, dataloading, children }) => {
  const [state, setState] = useState({
    hover : hover,
    items: [],
    filteredItems: [],
    options: {
      orderBy: '',
      orderDirection: '',
      sizes: [5, 10, 25, 50, 100, 250, 500, 'All'],
      size: 10,
      pages: 0,
      page: 1
    },
    columnsLabel: {},
    sortableColumns: [],
    noDataMessage: lang('No data to display'),
    setSortableColumns: (value) => setState(prevState => ({ ...prevState, sortableColumns: [...prevState.sortableColumns, value] })),
    setColumnsLabel: (index, value) => setState(prevState => ({ ...prevState, columnsLabel: { ...prevState.columnsLabel, [`col_${index}`]: value } })),
    setFilteredItems: (values) => setState(prevState => ({ ...prevState, filteredItems: values })),
    setItems: (values) => setState(prevState => ({ ...prevState, items: values })),
    setOrderBy: (value) => setState(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        orderBy: value,
        orderDirection: (prevState.options.orderBy === value) ? ((prevState.options.orderDirection === '' || prevState.options.orderDirection === 'desc') ? 'asc' : 'desc') : 'asc'
      }
    })),
    setSize: (value) => setState(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        size: value,
        page: 1
      }
    })),
    setPage: (value) => setState(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        page: value,
      }
    })),
    setPages: (value) => setState(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        pages: value,
      }
    }))
  });

  useMemo(() => { 
    if (!!dataSet) {
      state.setItems(dataSet);
    } else {
      state.setItems([]);
      state.setFilteredItems([])
    }
  }, [dataSet]);

  useEffect(() => {
    if (!!state.items && state.items.length > 0) {

      if (state.options.orderDirection === 'desc') {
        state.items.sort((a, b) => {
          const aValue = getDescendantProp(a, state.options.orderBy);
          const bValue = getDescendantProp(b, state.options.orderBy);
          return (aValue > bValue) ? 1 : ((bValue > aValue) ? -1 : 0)
        })
      } else {
        state.items.sort((a, b) => {
          const aValue = getDescendantProp(a, state.options.orderBy);
          const bValue = getDescendantProp(b, state.options.orderBy);
          return (aValue < bValue) ? 1 : ((bValue < aValue) ? -1 : 0)
        })
      }

      state.setPages(Math.ceil(state.items.length / state.options.size));

      state.setFilteredItems(state.items.slice(
        (state.options.page - 1) * state.options.size, state.options.page * state.options.size));
    }
  }, [
    state.options.orderDirection,
    state.options.orderBy,
    state.options.size,
    state.options.page,
    state.items
  ]);

  return (<TableContext.Provider value={state}>
    {(dataloading) ?
      <Loader /> :
      <>
        <table
          className={`bf-table ${(responsive !== false) ? 'responsive' : ''} ${(hover !== false) ? 'hover' : ''}`
          }>
          {children}
        </table>
        {(pagination) ? <Table.Paginator /> : null}
      </>
    }
  </TableContext.Provider>)
}

Table.Caption = Caption;
Table.Header = Header;
Table.Body = Body;
Table.Paginator = Paginator;

export { Table }